import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useSupplierInvoice, SupplierInvoice } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<SupplierInvoice>
      useData={useSupplierInvoice}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
